var exports = {
  "Vg": "ChatSkeleton.module__grid___QmdvUV",
  "wx": "ChatSkeleton.module__header___QmdvUV",
  "D_": "ChatSkeleton.module__identity___QmdvUV",
  "Ow": "ChatSkeleton.module__identityBack___QmdvUV",
  "um": "ChatSkeleton.module__identityBackDesktop___QmdvUV",
  "W": "ChatSkeleton.module__identityName___QmdvUV",
  "aL": "ChatSkeleton.module__identityCaret___QmdvUV",
  "lf": "ChatSkeleton.module__identityTopicDivider___QmdvUV",
  "$s": "ChatSkeleton.module__headerActions___QmdvUV",
  "QE": "ChatSkeleton.module__headerAction___QmdvUV",
  "YB": "ChatSkeleton.module__headerSearch___QmdvUV",
  "lQ": "ChatSkeleton.module__headerSearchIcon___QmdvUV",
  "Qs": "ChatSkeleton.module__content___QmdvUV",
  "ec": "ChatSkeleton.module__memberListDivider___QmdvUV",
  "oM": "ChatSkeleton.module__chatArea___QmdvUV",
  "JX": "ChatSkeleton.module__chatBody___QmdvUV",
  "DZ": "ChatSkeleton.module__messages___QmdvUV",
  "T_": "ChatSkeleton.module__composerInputLine___QmdvUV",
  "PN": "ChatSkeleton.module__composerAction___QmdvUV",
  "JD": "ChatSkeleton.module__memberList___QmdvUV",
  "Pz": "ChatSkeleton.module__memberListScroller___QmdvUV",
};

module.exports = exports;
